import { ActionReducer } from '@ngrx/store';
import { AgencyConfigEffects } from './agencyConfig/agencyConfig.effects';
import * as fromAgencyConfig from './agencyConfig/agencyConfig.reducer';
import * as fromShared from './shared/shared.reducer';
import { SHARED_STATE_NAME } from './shared/shared.selector';
export interface AppState {
  [SHARED_STATE_NAME]: fromShared.State;
}

export const reducers = {
  [SHARED_STATE_NAME]: fromShared.reducer,
};
export const agencyConfig = {
  key: 'agencyConfig',
  reducer:
    fromAgencyConfig.agencyConfigReducer as ActionReducer<fromAgencyConfig.AgencyConfigState>,
  effects: [AgencyConfigEffects],
};
